// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"2f131802","415":"e41bb905","571":"0028f717","859":"b2ab9594"}[chunkId] + ".chunk.css";
};